module.exports = __webpack_public_path__ + "static/media/login-bg-mtn.0dd8482b.jpg";